// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as CareersRouteImport } from './routes/careers'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AuthenticatedAdminRouteImport } from './routes/_authenticated/admin'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedFilesRouteImport } from './routes/_authenticated/files'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogChoosingAnAccountingPartnerRouteImport } from './routes/blog.choosing-an-accounting-partner'
import { Route as IndustriesIndexRouteImport } from './routes/industries.index'
import { Route as IndustriesCrossBorderIndiaUsRouteImport } from './routes/industries.cross-border-india-us'
import { Route as IndustriesEcommerceRouteImport } from './routes/industries.ecommerce'
import { Route as IndustriesNonprofitsRouteImport } from './routes/industries.nonprofits'
import { Route as IndustriesProfessionalServicesRouteImport } from './routes/industries.professional-services'
import { Route as IndustriesSaasRouteImport } from './routes/industries.saas'
import { Route as IndustriesStartupsRouteImport } from './routes/industries.startups'
import { Route as QuoteTokenRouteImport } from './routes/quote.$token'
import { Route as ServicesIndexRouteImport } from './routes/services.index'
import { Route as ServicesAccountingRouteImport } from './routes/services.accounting'
import { Route as ServicesAccountsPayableRouteImport } from './routes/services.accounts-payable'
import { Route as ServicesAccountsReceivableRouteImport } from './routes/services.accounts-receivable'
import { Route as ServicesBookkeepingRouteImport } from './routes/services.bookkeeping'
import { Route as ServicesCatchUpCleanupRouteImport } from './routes/services.catch-up-cleanup'
import { Route as ServicesCfoControllerSupportRouteImport } from './routes/services.cfo-controller-support'
import { Route as ServicesFinanceProcessOutsourcingRouteImport } from './routes/services.finance-process-outsourcing'
import { Route as ServicesFinancialReportingRouteImport } from './routes/services.financial-reporting'
import { Route as ServicesMonthEndCloseRouteImport } from './routes/services.month-end-close'
import { Route as ServicesPayrollRouteImport } from './routes/services.payroll'
import { Route as ServicesQuickbooksXeroRouteImport } from './routes/services.quickbooks-xero'
import { Route as ServicesReconciliationsRouteImport } from './routes/services.reconciliations'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const CareersRoute = CareersRouteImport.update({
            id: '/careers',path: '/careers',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const PricingRoute = PricingRouteImport.update({
            id: '/pricing',path: '/pricing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SecurityRoute = SecurityRouteImport.update({
            id: '/security',path: '/security',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AuthenticatedAdminRoute = AuthenticatedAdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedFilesRoute = AuthenticatedFilesRouteImport.update({
            id: '/files',path: '/files',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AuthenticatedRouteRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogChoosingAnAccountingPartnerRoute = BlogChoosingAnAccountingPartnerRouteImport.update({
            id: '/blog/choosing-an-accounting-partner',path: '/blog/choosing-an-accounting-partner',getParentRoute: () => rootRouteImport
          })
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
            id: '/industries/',path: '/industries/',getParentRoute: () => rootRouteImport
          })
const IndustriesCrossBorderIndiaUsRoute = IndustriesCrossBorderIndiaUsRouteImport.update({
            id: '/industries/cross-border-india-us',path: '/industries/cross-border-india-us',getParentRoute: () => rootRouteImport
          })
const IndustriesEcommerceRoute = IndustriesEcommerceRouteImport.update({
            id: '/industries/ecommerce',path: '/industries/ecommerce',getParentRoute: () => rootRouteImport
          })
const IndustriesNonprofitsRoute = IndustriesNonprofitsRouteImport.update({
            id: '/industries/nonprofits',path: '/industries/nonprofits',getParentRoute: () => rootRouteImport
          })
const IndustriesProfessionalServicesRoute = IndustriesProfessionalServicesRouteImport.update({
            id: '/industries/professional-services',path: '/industries/professional-services',getParentRoute: () => rootRouteImport
          })
const IndustriesSaasRoute = IndustriesSaasRouteImport.update({
            id: '/industries/saas',path: '/industries/saas',getParentRoute: () => rootRouteImport
          })
const IndustriesStartupsRoute = IndustriesStartupsRouteImport.update({
            id: '/industries/startups',path: '/industries/startups',getParentRoute: () => rootRouteImport
          })
const QuoteTokenRoute = QuoteTokenRouteImport.update({
            id: '/quote/$token',path: '/quote/$token',getParentRoute: () => rootRouteImport
          })
const ServicesIndexRoute = ServicesIndexRouteImport.update({
            id: '/services/',path: '/services/',getParentRoute: () => rootRouteImport
          })
const ServicesAccountingRoute = ServicesAccountingRouteImport.update({
            id: '/services/accounting',path: '/services/accounting',getParentRoute: () => rootRouteImport
          })
const ServicesAccountsPayableRoute = ServicesAccountsPayableRouteImport.update({
            id: '/services/accounts-payable',path: '/services/accounts-payable',getParentRoute: () => rootRouteImport
          })
const ServicesAccountsReceivableRoute = ServicesAccountsReceivableRouteImport.update({
            id: '/services/accounts-receivable',path: '/services/accounts-receivable',getParentRoute: () => rootRouteImport
          })
const ServicesBookkeepingRoute = ServicesBookkeepingRouteImport.update({
            id: '/services/bookkeeping',path: '/services/bookkeeping',getParentRoute: () => rootRouteImport
          })
const ServicesCatchUpCleanupRoute = ServicesCatchUpCleanupRouteImport.update({
            id: '/services/catch-up-cleanup',path: '/services/catch-up-cleanup',getParentRoute: () => rootRouteImport
          })
const ServicesCfoControllerSupportRoute = ServicesCfoControllerSupportRouteImport.update({
            id: '/services/cfo-controller-support',path: '/services/cfo-controller-support',getParentRoute: () => rootRouteImport
          })
const ServicesFinanceProcessOutsourcingRoute = ServicesFinanceProcessOutsourcingRouteImport.update({
            id: '/services/finance-process-outsourcing',path: '/services/finance-process-outsourcing',getParentRoute: () => rootRouteImport
          })
const ServicesFinancialReportingRoute = ServicesFinancialReportingRouteImport.update({
            id: '/services/financial-reporting',path: '/services/financial-reporting',getParentRoute: () => rootRouteImport
          })
const ServicesMonthEndCloseRoute = ServicesMonthEndCloseRouteImport.update({
            id: '/services/month-end-close',path: '/services/month-end-close',getParentRoute: () => rootRouteImport
          })
const ServicesPayrollRoute = ServicesPayrollRouteImport.update({
            id: '/services/payroll',path: '/services/payroll',getParentRoute: () => rootRouteImport
          })
const ServicesQuickbooksXeroRoute = ServicesQuickbooksXeroRouteImport.update({
            id: '/services/quickbooks-xero',path: '/services/quickbooks-xero',getParentRoute: () => rootRouteImport
          })
const ServicesReconciliationsRoute = ServicesReconciliationsRouteImport.update({
            id: '/services/reconciliations',path: '/services/reconciliations',getParentRoute: () => rootRouteImport
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAdminRoute: AuthenticatedAdminRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedFilesRoute: AuthenticatedFilesRoute,AuthenticatedSettingsRoute: AuthenticatedSettingsRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AuthRoute: AuthRoute,CareersRoute: CareersRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,HowItWorksRoute: HowItWorksRoute,PricingRoute: PricingRoute,PrivacyRoute: PrivacyRoute,ResetPasswordRoute: ResetPasswordRoute,SecurityRoute: SecurityRoute,TermsRoute: TermsRoute,BlogChoosingAnAccountingPartnerRoute: BlogChoosingAnAccountingPartnerRoute,IndustriesCrossBorderIndiaUsRoute: IndustriesCrossBorderIndiaUsRoute,IndustriesEcommerceRoute: IndustriesEcommerceRoute,IndustriesNonprofitsRoute: IndustriesNonprofitsRoute,IndustriesProfessionalServicesRoute: IndustriesProfessionalServicesRoute,IndustriesSaasRoute: IndustriesSaasRoute,IndustriesStartupsRoute: IndustriesStartupsRoute,QuoteTokenRoute: QuoteTokenRoute,ServicesAccountingRoute: ServicesAccountingRoute,ServicesAccountsPayableRoute: ServicesAccountsPayableRoute,ServicesAccountsReceivableRoute: ServicesAccountsReceivableRoute,ServicesBookkeepingRoute: ServicesBookkeepingRoute,ServicesCatchUpCleanupRoute: ServicesCatchUpCleanupRoute,ServicesCfoControllerSupportRoute: ServicesCfoControllerSupportRoute,ServicesFinanceProcessOutsourcingRoute: ServicesFinanceProcessOutsourcingRoute,ServicesFinancialReportingRoute: ServicesFinancialReportingRoute,ServicesMonthEndCloseRoute: ServicesMonthEndCloseRoute,ServicesPayrollRoute: ServicesPayrollRoute,ServicesQuickbooksXeroRoute: ServicesQuickbooksXeroRoute,ServicesReconciliationsRoute: ServicesReconciliationsRoute,BlogIndexRoute: BlogIndexRoute,IndustriesIndexRoute: IndustriesIndexRoute,ServicesIndexRoute: ServicesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)